export default function themeTypography(theme) {
  return {
    fontFamily: theme?.customization?.fontFamily,
    h6: {
      fontSize: "1rem",
      color: theme.heading,
      fontWeight: 500,
      lineHeight: 1.5,
    },
    h5: {
      fontSize: "1.25rem",
      color: theme.heading,
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: "1.5rem",
      color: theme.heading,
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h3: {
      fontSize: "1.75rem",
      color: theme.heading,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h2: {
      fontSize: "2rem",
      color: theme.heading,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h1: {
      fontSize: "2.5rem",
      color: theme.heading,
      fontWeight: 500,
      lineHeight: 1.2,
    },
    subtitle1: {
      fontSize: "1rem",
      color: theme.textDark,
      fontWeight: 400,
      lineHeight: 1.75,
    },
    subtitle2: {
      fontSize: "0.875rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
      lineHeight: 1.57,
    },
    caption: {
      fontSize: "0.75rem", // 12px - Help text, labels
      color: theme.darkTextSecondary,
      lineHeight: 1.66,
      letterSpacing: "0.03333em",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: "0.00938em",
    },
    body2: {
      fontSize: "0.875rem", // 14px - Secondary content
      color: theme.darkTextPrimary,
      lineHeight: 1.43,
      letterSpacing: "0.01071em",
    },
    button: {
      fontSize: "0.875rem", // 14px - Button text
      textTransform: "capitalize",
      fontWeight: 500,
    },
    overline: {
      fontSize: "0.75rem", // 12px - Category labels
      textTransform: "uppercase",
      letterSpacing: "0.08333em",
    },
    customInput: {
      marginTop: 1,
      marginBottom: 1,
      "& > label": {
        top: 23,
        left: 0,
        color: theme.grey500,
        '&[data-shrink="false"]': {
          top: 5,
        },
      },
      "& > div > input": {
        padding: "30.5px 14px 11.5px !important",
      },
      "& legend": {
        display: "none",
      },
      "& fieldset": {
        top: 0,
      },
    },
    mainContent: {
      backgroundColor: theme.background,
      width: "100%",
      minHeight: "calc(100vh - 88px)",
      flexGrow: 1,
      padding: "20px",
      marginTop: "88px",
      marginRight: "20px",
      borderRadius: `${theme?.customization?.borderRadius}px`,
    },
    menuCaption: {
      fontSize: "0.875rem",
      fontWeight: 500,
      color: theme.heading,
      padding: "6px",
      textTransform: "capitalize",
      marginTop: "10px",
    },
    subMenuCaption: {
      fontSize: "0.6875rem",
      fontWeight: 500,
      color: theme.darkTextSecondary,
      textTransform: "capitalize",
    },
    commonAvatar: {
      cursor: "pointer",
      borderRadius: "8px",
    },
    smallAvatar: {
      width: "22px",
      height: "22px",
      fontSize: "1rem",
    },
    mediumAvatar: {
      width: "34px",
      height: "34px",
      fontSize: "1.2rem",
    },
    largeAvatar: {
      width: "44px",
      height: "44px",
      fontSize: "1.5rem",
    },
  };
}
